import { render, staticRenderFns } from "./FooterIcons.vue?vue&type=template&id=28997d3c"
import script from "./FooterIcons.vue?vue&type=script&lang=ts"
export * from "./FooterIcons.vue?vue&type=script&lang=ts"
import style0 from "./FooterIcons.vue?vue&type=style&index=0&id=28997d3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports